export default function Backups() {
  return (
    <section id="backups">
      <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-6">Backups</h2>

      <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900 p-5 space-y-4 text-sm text-slate-600 dark:text-slate-400">
        <p>
          Bedrock Toolchest creates a backup of your world every time you save changes (unless you
          have disabled automatic backups in Settings). The Backups tab lets you manage these backups.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="font-medium text-slate-800 dark:text-slate-200 mb-2">Backup List</h3>
            <p>
              The left panel shows all backups for the current world, ordered by date. Each entry shows
              when the backup was created, its size, and whether it was created automatically or
              manually. Backups are tagged with <strong>[Auto]</strong> or <strong>[Manual]</strong> labels
              so you can tell them apart.
            </p>
            <ul className="space-y-1 mt-2">
              <li><strong>Refresh</strong> — Reload the backup list.</li>
              <li><strong>Create Backup</strong> — Manually create a backup at any time, even if you haven't made changes. Manual backups are exempt from automatic retention cleanup — only automatic backups rotate when the retention limit is reached.</li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-slate-800 dark:text-slate-200 mb-2">Backup Actions</h3>
            <p>
              The right panel shows details about the selected backup and provides actions:
            </p>
            <ul className="space-y-1 mt-2">
              <li><strong>Restore</strong> — Replace the current world with this backup. The current world state is backed up first so you can undo the restore if needed.</li>
              <li><strong>Lock / Unlock</strong> — Lock a backup to protect it from automatic retention cleanup. Locked backups are never automatically deleted, regardless of the retention limit. Unlock to allow normal rotation again.</li>
              <li><strong>Verify</strong> — Check that the backup file is intact and can be restored.</li>
              <li><strong>Delete</strong> — Remove a backup you no longer need.</li>
            </ul>
          </div>
        </div>

        <div className="rounded-lg border border-blue-200 dark:border-blue-800/50 bg-blue-50 dark:bg-blue-900/20 p-3">
          <p className="text-blue-700 dark:text-blue-400 text-xs">
            Backups are stored in a "backups" folder next to your world. They're compressed zip files
            that contain a full copy of your world at the time of the backup.
          </p>
        </div>

        <div>
          <h3 className="font-medium text-slate-800 dark:text-slate-200 mb-2">Compact Database</h3>
          <p>
            When a world is loaded, the app checks the database for fragmentation. If significant
            fragmentation is detected, a <strong>Compact DB</strong> button appears in the footer
            bar. Clicking it compacts the world's database to reduce file count and reclaim disk
            space. If backups are enabled, an automatic backup is created before compaction begins.
          </p>
        </div>
      </div>
    </section>
  );
}
